import { render } from "./TileWithoutPopup.vue?vue&type=template&id=0ffc1c25&scoped=true"
import script from "./TileWithoutPopup.vue?vue&type=script&lang=js"
export * from "./TileWithoutPopup.vue?vue&type=script&lang=js"

import "./TileWithoutPopup.vue?vue&type=style&index=0&id=0ffc1c25&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ffc1c25"]])

export default __exports__